export default __webpack_public_path__ + "static/media/site_transfavo.b0b15111.webp";